<div *ngIf="this.forgotPasawordStatus===3">
    <div class="basicrow f-lsemi roboto-r text-center">
        <div class="basicrow">
            <img width="100%" class="mc-icon" src="../../assets/images/reg-c-icon.png">
            ¿Olvidaste tu contraseña?
        </div>
    </div>
    <div>
        <div>
            Debe modificar la clave de acceso para poder ingresar a su cuenta Claro.
        </div>
        <div class="basicrow m-top-i">
        <label class="label-f">Contraseña Temporal</label>
            <div class="basicrow">

                <input class="inp-f" type="password" [(ngModel)]="this.currentPassword" autocomplete="off">
            </div>
        </div>
        <div class="basicrow m-top-i">
            <label class="label-f">Nueva Contraseña</label>
            <div class="basicrow">
                <input class="inp-f" maxlength="15" type="password" [(ngModel)]="this.password" (keyup)="onKey($event)" autocomplete="off">
                <app-password-validator (validatePassword)="validatePassword=$event" ></app-password-validator>
            </div>
        </div>
        <div class="basicrow m-top-i">
            <label class="label-f">Confirmar Contraseña</label>
            <div class="basicrow">

                <input class="inp-f" type="password" [(ngModel)]="this.passwordConf" autocomplete="off">
            </div>
        </div>
        <div class="basicrow m-top-i">
            <a (click)="this.continue();" class="btns red vcenter">
                <span class="tabcell">
                    Continuar&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>
                </span>
            </a>
        </div>
    </div>
</div>
